class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', onKeyUpEscape);
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open')
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

document.addEventListener('DOMContentLoaded', () => {
  const childMenuWrapper = document.querySelector('.child-menu-wrapper-desktop');

  childMenuWrapper.addEventListener('click', (event) => {
    if (event.target.tagName.toLowerCase() === 'summary') {
        const details = event.target.parentElement;

        // Sprawdź, czy kliknięty element ma atrybut "open"
        if (details.hasAttribute('open')) {
            // Usuń atrybut "open", aby zapobiec zamknięciu
            event.preventDefault();
        } else {
            // Zamykanie innych otwartych elementów
            const openDetails = childMenuWrapper.querySelectorAll('details[open]');
            openDetails.forEach((openDetail) => {
                openDetail.removeAttribute('open');
            });

            // Otwarcie klikniętego elementu
            
        }
    }
});

const mainDetails = document.querySelector('.main-details');
const menuOverlayOpen = document.querySelector('.menu_overlay_open');

function updateMenuOverlay() {
    if (mainDetails.hasAttribute('open')) {
        menuOverlayOpen.classList.add('active');
    } else {
        menuOverlayOpen.classList.remove('active');
    }
}

const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'open') {
            updateMenuOverlay();
        }
    });
});

observer.observe(mainDetails, {
    attributes: true
});

document.addEventListener('click', function(event) {
    const isClickInsideMainDetails = mainDetails.contains(event.target);
    const isClickInsideHeaderSubmenu = document.querySelector('.header__submenu').contains(event.target);

    if (!isClickInsideMainDetails && !isClickInsideHeaderSubmenu && mainDetails.hasAttribute('open')) {
        mainDetails.removeAttribute('open');
    }
});

 
});
